import { render, staticRenderFns } from "@/modules/PhoneLog/templates/phone-log-list.html?vue&type=template&id=37a2c208&scoped=true&"
import script from "@/modules/PhoneLog/scripts/phone-log-list.ts?vue&type=script&lang=js&"
export * from "@/modules/PhoneLog/scripts/phone-log-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/PhoneLog/styles/phone-log-list.scss?vue&type=style&index=0&id=37a2c208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2c208",
  null
  
)

export default component.exports